import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button, Col, Modal, Row, Image } from "react-bootstrap";
import ContactLens2 from "./ContactLensComponent/ContactLens2";
import ContactCase3 from "./ContactLensComponent/ContactCase3";
import ContactCase4 from "./ContactLensComponent/ContactCase4";

function ContactlensModal({
  type,
  setType,
  product,
  addToCartHandler,
  setSpecification,
  Specification,
}) {
  const [show, setShow] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(true);
  const [activeKey, setActiveKey] = useState("");
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        // Adjust the breakpoint as per your needs
        setIsFullscreen(false);
      } else {
        setIsFullscreen(true);
      }
    };

    handleResize(); // Initial check

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const initialFormValues = {
    od_sph: 0,
    od_cyl: 0,
    od_axis: 0,
    os_sph: 0,
    os_cyl: 0,
    os_axis: 0,
    Add_Power: 0,
    pd_type: " ",
    pd_value: 0,
    PrescriptionImage: " ",
  };
  const [formData, setFormData] = useState(initialFormValues);
  const handleChange = (fieldName, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [fieldName]: value,
    }));
  };
  const handleShow = () => {
    setShow(true);
  };
  const Handleform1 = (value) => {
    setSpecification({ ...Specification, prescriptionType: value });
    setType("3");
  };
  const uploadPrescriptionHandler = async (e) => {
    const file = e.target.files[0];
    const formData1 = new FormData();
    formData1.append("PrescriptionImage", file);

    try {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      const { data } = await axios.post(
        "/api/upload/PrescriptionImage",
        formData1,
        config
      );

      const ImageId = data.substring(data.lastIndexOf("-") + 1);

      setFormData({
        ...formData,
        PrescriptionImage: ImageId,
      });
    } catch (error) {
      console.error(error);
    }
  };
  const Handleform2 = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
    } else {
      setSpecification(() => ({
        ...Specification,
        ManualValues: formData,
      }));
      setType("4");
    }
  };
  const handleClose = () => {
    setType("2");
    setSpecification({
      ...Specification,
      // frame: "",
      prescriptionType: " ",
      qty: 1,
      ManualValues: {
        od_sph: 0,
        od_cyl: 0,
        od_axis: 0,
        os_sph: 0,
        os_cyl: 0,
        os_axis: 0,
        Add_Power: 0,
        pd_type: " ",
        pd_value: 0,
        PrescriptionImage: " ",
      },
    });
    setShow(false);
  };
  const handleBack1 = () => {
    setFormData({
      ...formData,
      PrescriptionImage: " ",
      od_sph: 0,
      od_cyl: 0,
      od_axis: 0,
      os_sph: 0,
      os_cyl: 0,
      os_axis: 0,
      Add_Power: 0,
      pd_type: " ",
      pd_value: 0,
    });
    setType("2");
  };
  const handleBack2 = () => {
    setFormData({
      ...formData,
      PrescriptionImage: " ",
      od_sph: 0,
      od_cyl: 0,
      od_axis: 0,
      os_sph: 0,
      os_cyl: 0,
      os_axis: 0,
      Add_Power: 0,
      pd_type: " ",
      pd_value: 0,
    });
    setType("3");
  };
  return (
    <>
      <Row className='text-center'>
        <Button
          type='button'
          onClick={handleShow}
          disabled={product.countInStock === 0}
          className=' Psbutton shadow btn-light m-2'
        >
          Buy Lens
        </Button>
      </Row>

      <Modal
        //  when the modal body ka cheeze badh jaye toh scrollable karke ek feature daal sakte hai
        animation
        backdrop='static'
        // size='xl'
        dialogClassName={isFullscreen ? "" : "modal-xl"}
        fullscreen={isFullscreen}
        show={show}
        onHide={handleClose}
      >
        <Row style={{ height: "100%" }}>
          <Col style={{ margin: "auto" }} className='text-center' md={4}>
            <Image src={product.image} alt={product.name} fluid />
            <h3>{product.name}</h3>
          </Col>

          {(() => {
            switch (type) {
              case "2":
                return (
                  <ContactLens2
                    handleClose={handleClose}
                    Handleform1={Handleform1}
                  />
                );

              case "3":
                return (
                  <ContactCase3
                    handleBack1={handleBack1}
                    Handleform2={Handleform2}
                    handleChange={handleChange}
                    activeKey={activeKey}
                    setActiveKey={setActiveKey}
                    Specification={Specification}
                    uploadPrescriptionHandler={uploadPrescriptionHandler}
                  />
                );
              case "4":
                return (
                  <ContactCase4
                    handleBack2={handleBack2}
                    Specification={Specification}
                    product={product}
                    setSpecification={setSpecification}
                    addToCartHandler={addToCartHandler}
                  />
                );

              default:
                return (
                  <Col>
                    Sorry some Error is there, The technical team is looking
                    into it.
                  </Col>
                );
            }
          })()}
        </Row>
      </Modal>
    </>
  );
}

export default ContactlensModal;
